import { languagesOptions } from 'api/types/languages';
import {
  Departments,
  salutations,
  Segments,
  userPlatformInterests,
  userProductInterests
} from '../../../../api/types/ReferenceData';
import { countries } from '../../../../helpers/countries';

export const profileFormFields = {
  email: { name: 'email', type: 'email', label: 'Email', editable: false },
  company: { name: 'company', type: 'text', label: 'Company', editable: false },
  bio: {
    name: 'bio',
    type: 'textarea',
    label: '',
    editable: true
  },
  firstname: {
    name: 'firstname',
    type: 'string',
    label: 'First name',
    editable: true
  },
  lastname: {
    name: 'lastname',
    type: 'string',
    label: 'Last name',
    editable: true
  },
  job_title: {
    name: 'job_title',
    type: 'string',
    label: 'Job title',
    editable: true
  },
  productInterests: {
    name: 'interests',
    type: 'autocomplete',
    label: 'Product interests',
    options: userProductInterests,
    editable: true,
    isMulti: true
  },
  platformInterests: {
    name: 'platformInterests',
    type: 'select',
    label: 'Product interests',
    options: userPlatformInterests,
    editable: true,
    isMulti: true
  },
  salutation: {
    name: 'salutation',
    type: 'select',
    options: salutations,
    label: 'Salutation',
    editable: true
  },
  country_code: {
    name: 'country_code',
    type: 'select',
    options: countries,
    label: 'Country',
    editable: true
  },
  department: {
    name: 'department',
    type: 'select',
    options: Departments,
    label: 'Department',
    editable: true
  },
  segments: {
    name: 'segments',
    type: 'autocomplete',
    options: Segments,
    label: 'Segments',
    editable: true,
    isMulti: true
  },
  shipping_address: {
    company: {
      name: 'shipping_address.company',
      type: 'string',
      label: 'Company',
      editable: true
    },
    personOfContact: {
      name: 'shipping_address.person_of_contact',
      type: 'string',
      label: 'Contact person',
      editable: true
    },

    city: {
      name: 'shipping_address.city',
      type: 'string',
      label: 'City',
      editable: true
    },
    street: {
      name: 'shipping_address.street',
      type: 'string',
      label: 'Street',
      editable: true
    },
    street_additional: {
      name: 'shipping_address.street_additional',
      type: 'string',
      label: '',
      editable: true
    },
    postal_code: {
      name: 'shipping_address.postal_code',
      type: 'string',
      label: 'Postal code',
      editable: true
    },
    country: {
      name: 'shipping_address.country',
      type: 'select',
      options: countries,
      label: 'Country',
      editable: true
    },
    country_code: {
      name: 'shipping_address.country_code',
      type: 'string',
      label: 'Country',
      editable: true
    }
  },
  languages: {
    name: 'languages',
    type: 'select',
    options: languagesOptions,
    label: 'Spoken languages',
    editable: true,
    isMulti: true
  },
  newsletter: {
    name: 'newsletter',
    type: 'checkbox',
    label: 'Subscribe newsletter',
    editable: true
  }
};
